<template>
  <!-- <div id="app" :class="{ 'disabled-scroll': loading }"> -->
  <div id="app">
    <div class="content-container">
      <div class="loading" v-show="loading" v-loading.body="loading"
        element-loading-text="Đang tải dữ liệu vui lòng đợi..."></div>
      <div v-if="isLogged">
        <gs-menu></gs-menu>
      </div>
      <div class="content-container">
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <button class="ui icon mini button red dev-tool" v-if="devTool" @click="dialogDebug = true">
      <i class="fa fa-bug"></i>
    </button>
    <div class="debug" v-if="devTool">
      <el-dialog title="Debug queries" :visible.sync="dialogDebug" :fullscreen="true">
        <el-table :data="debugQuery" border style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <table class="table">
                <thead>
                  <tr class="debug-text">
                    <th>Query</th>
                    <th>File</th>
                    <th>Execute time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="statement in props.row.statements" :key="statement.stmt_id" class="debug-text cursor-pointer"
                    @click="showDebugDialog(statement)">
                    <td>{{ statement.sql }}</td>
                    <td>{{ statement.stmt_id }}</td>
                    <td>{{ statement.duration_str }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </el-table-column>
          <el-table-column width="60" label="Method" prop="method" class-name="debug-text">
          </el-table-column>
          <el-table-column label="Url" prop="uri" class-name="debug-text">
          </el-table-column>
          <el-table-column label="File" prop="file" class-name="debug-text">
          </el-table-column>
          <el-table-column label="Middleware" prop="middleware" width="200" class-name="debug-text">
          </el-table-column>
          <el-table-column width="60" label="Memory" prop="memory" class-name="debug-text">
          </el-table-column>
          <el-table-column width="80" label="Execute time" prop="accumulated_duration_str" class-name="debug-text">
          </el-table-column>
          <el-table-column width="60" label="Queries" prop="nb_statements" class-name="debug-text">
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="Debug query params" :visible.sync="dialogDebugQuery">
        <pre class="debug-text">{{ dialogData }}</pre>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import GsMenu from 'components/app/GsMenu'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  components: {
    GsMenu
  },
  data() {
    return {
      dialogDebug: false,
      dialogDebugQuery: false,
      dialogData: [],
      devTool: false
    }
  },
  computed: {
    ...mapGetters(['isLogged', 'loading', 'debugQuery'])
  },
  methods: {
    ...mapActions(['checkLogged']),
    showDebugDialog(statement) {
      this.dialogData = statement.stt_exp
      this.dialogDebugQuery = true
    }
  },
  mounted() {
    this.checkLogged()
    if (process.env.NODE_ENV === 'development') {
      this.devTool = true
    }
  },
  watch: {
    debugQuery: {
      handler: function (value) {
        if (value.length) {
          this.devTool = true
        }
      },
      deep: true
    }
  }
}
</script>

<style type="text/css" scoped>
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.dev-tool {
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?43069365